import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { willNeverHappen } from "healthex-common/utils";
import { LoginFlowViewModel } from "./LoginFlowViewModel";
import { LoginPage } from "./LoginUIManager";
import { LoginView } from "./LoginView";
import { PatientLandingView } from "./PatientLandingView";
import { UserLoginTypeSelectView } from "./UserLoginTypeSelectView";
import { useViewModel } from "./useViewModel";
export const LoginFlowView = observer((props) => {
    const model = useViewModel(LoginFlowViewModel, props.container);
    switch (model.loginPage) {
        case null:
            return null;
        case LoginPage.SELECT_USER_LOGIN_TYPE:
            return _jsx(UserLoginTypeSelectView, { container: props.container });
        case LoginPage.ORG_USER_LOGIN:
            return _jsx(LoginView, { container: props.container });
        case LoginPage.PATIENT_LOGIN:
            return _jsx(PatientLandingView, { container: props.container });
    }
    return willNeverHappen(model.loginPage);
});
